import * as types from '../_actions/actionTypes';
import _ from 'lodash';

const _actionTypes = [];

export function ActionTypesReducer(
  state = { actionTypes: _actionTypes },
  action
) {
  switch (action.type) {
    case types.FETCH_ACTION_LIST:
      return Object.assign({}, state, {
        actionTypes: action.payload
      });
    case types.FETCH_ACTION_LIST_FAILURE:
      return Object.assign({}, state, {
        actionTypes: _actionTypes
      });
    default:
      return state;
  }
}
